import React, {
  useRef,
  useMemo,
  useState,
  useEffect,
} from 'react';
import moment from 'moment';

import { OverlayTrigger, PopOver } from '@tencent/spaui';
import { ListView } from '@tencent/ptp-fe-common';
import { RPCFactory } from '../../../utils/RequestUtil';
// import { Tags } from '../../../consts/Tags';
// import { LeadsDataFilterShortcut as DATE_SHORTCUTS } from '../../../consts/Common'
const leadsTouchTag = {
  0: '待联系',
  4: '未接通-无效号码',
  1: '未接通-其他',
  2: '已接通-未响应',
  3: '已接通-已响应',
}
let CMcurrentPage = 1;
let renderList = []
const FieldPage = () => {
  const lvRef = useRef();
  const [leadsOwners, setLeadsOwners] = useState([])
  const [callStatus, setCallStatus] = useState('')

  const initQuery = {
    addTime: {
      start_time: moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  };
  const getTouchTagNum = (data) => {
    let callTagStatus = 0;
    const duration = parseInt(data.duration);
    if (duration == 0) {
      callTagStatus = 1;
    } else if (duration < 10) {
      callTagStatus = 2;
    } else {
      callTagStatus = 3;
    }
    return callTagStatus;
  };
  const renderRecordUrlTimeLimited = (type, name, value, data) => {
    if (type == 'head') return value;

    if ([2, 3].indexOf(getTouchTagNum(data)) < 0) {
      // 只有未回应和已回应才显示调听按钮
      return '';
    }

    return (
      <a href="javascript:void(0)" onClick={() => { getRecord(data) }}>
        调听
      </a>
    );
  };

  const getRecord = (record) => {
    RPCFactory.leadsManage
      .getLeadsCallRecordUrl(record.leadsId, record.id)
      .done((data) => {
        window.open(data, '_blank');
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };
  const remove86 = (telphone) => {
    // 去掉+86和0086，如果是座机号码，前面加0
    if (telphone.indexOf('+86') === 0 || telphone.indexOf('0086') === 0) {
      let newphone = telphone.replace('0086', "");
      newphone = newphone.replace('+86', "");
      if (newphone.indexOf('1') === 0 && newphone.length === 11) {
        return newphone
      } else {
        return `0${newphone}`
      }
    } else {
      return telphone
    }
  }
  const columnMap = [
    { name: 'name', title: '用户姓名' },
    {
      name: 'userTel', title: '用户电话', render: (type, name, value, data) => {
        if (type == 'head') return value;
        return remove86(data.userTel)
      }
    },
    { name: 'operatorName', title: '员工' },

    {
      name: 'middleNumber',
      title: '中间号',
      notice: '联系用户时不要直接回拨中间号，在线索管理中进行外呼',
      render: (type, name, value, data) => {
        if (type == 'head') return value;
        return remove86(data.middleNumber)
      }
    },

    {
      name: 'consumerHotline',
      title: '客服电话',
      render: (type, name, value, data) => {
        if (type == 'head') return value;
        return remove86(data.consumerHotline)
      }
    },
    { name: 'leadsId', title: '线索ID' },
    {
      name: 'callStatus',
      title: '通话状态',
      render: (type, name, value, data) => {
        if (type == 'head') return value;
        return getTouchTagNum(data) === 1 ? `${data.callFailReasonDesc}` : `${leadsTouchTag[getTouchTagNum(data)]}`;

      }
    },
    {
      name: 'callPlatform',
      title: '平台',
      // notice: '智能电话-直呼：智能电话线索通话记录<br/>平台-网络：使用网络电话方式外呼<br/>平台-直呼：使用线索管理平台小程序直呼<br/>平台-双呼：使用双向回呼方式外呼<br/>录音：建议在通话结束后7天内调听录音',
      render: (type, name, value, data) => {
        if (type == 'head') return value;
        switch (value) {
          case 0:
            return '智能电话'
          case 1:
            return '线索平台'
          case 4:
            return '小程序'
        }
      }
    },
    {
      name: 'callMethod', title: '外呼类型', render: (type, name, value, data) => {
        if (type == 'head') return value;
        switch (value) {
          case '0':
            return '单向呼叫'
          case '4':
            return '双向回呼'
          case '5':
            return '网络电话'
        }
      }
    },
    {
      name: 'source', title: '操作端', render: (type, name, value, data) => {
        if (type == 'head') return value;
        switch (value) {
          case 4:
            return '移动端'
          case 0:
            return 'PC端'
          default:
            return '未知'

        }
      }
    },

    { name: 'callDirection', title: '呼叫类型' },
    { name: 'durationFormat', title: '通话时长' },
    { name: 'createdTime', title: '呼叫时间' },
    { name: 'callStatus', title: '通话录音', render: renderRecordUrlTimeLimited, notice: '建议在通话结束后7天内进行调听录音' },

  ]
  const filterControls = () => {
    return [

      {
        name: 'name',
        title: '用户姓名',
        type: 'search',
      },
      {
        name: 'tel',
        title: '用户电话',
        type: 'search',
      },

      {
        name: 'addTime',
        title: '呼叫时间',
        type: 'date-picker',
        clearable: false,
        config: {
          type: 'range',
          longestRange: '365',
        },
      },
      {
        name: 'userIds',
        title: '员工',
        type: 'select',
        config: {
          multiple: true,
          data: leadsOwners,
        },
      },

      {
        name: 'middleNumber',
        title: '中间号',
        type: 'search',
      },

      {
        name: 'callPlatforms',
        title: '平台',
        type: 'select',
        config: {
          multiple: true,
          data: [
            { value: 0, label: '智能电话' },
            { value: 1, label: '线索平台' },
            // { value: 4, label: '小程序' },
          ]
        },
      },
      {
        name: 'callMethods',
        title: '外呼类型',
        type: 'select',
        config: {
          multiple: true,
          data: [
            { value: 0, label: '单向呼叫' },
            { value: 4, label: '双向回呼' },
            { value: 5, label: '网络电话' },
          ]
        },
      },
      {
        name: 'sources',
        title: '操作端',
        type: 'select',
        config: {
          multiple: true,
          data: [
            { value: 0, label: 'PC端' },
            { value: 4, label: '移动端' },
          ]
        },
      },
      {
        name: 'callDirection',
        title: '呼叫类型',
        type: 'select',
        config: {
          multiple: false,
          data: [
            { value: 1, label: '呼入' },
            { value: 2, label: '呼出' },
          ]
        },
      },
      {
        name: 'callStatus',
        title: '通话状态',
        type: 'select',
        config: {
          multiple: false,
          data: [
            { value: 2, label: '已接通-未响应' },
            { value: 3, label: '已接通-已响应' },
            {
              value: 1,
              label: '未接通',
            },
          ]
        },
      },
      ...callStatus === 1 ? [{
        name: 'callFailReasons',
        title: '未接通原因',
        type: 'select',
        config: {
          multiple: true,
          data: [
            { value: 7, label: '未接通-空号' },
            { value: 1, label: '未接通-拒接' },
            { value: 3, label: '未接通-关机' },
            { value: 4, label: '未接通-停机' },
            { value: 2, label: '未接通-无人接听' },
            { value: 6, label: '未接通-暂时无法接通' },
            { value: 5, label: '未接通-正在通话中' },
            { value: 8, label: '未接通主叫挂断' },
            { value: 10, label: '未接通-其他' },
          ]
        },
      }] : [],
    ]
  };

  const getOwnerIds = () => {
    RPCFactory.employeeManage
      .getEmployees(undefined, undefined, undefined, undefined, undefined, undefined)
      .done((data) => {
        const leadsOwner = [];
        (data.entities || []).forEach((employee) => {
          // var mark = employee.status == EmployeeFrozenStatus.NORMAL ? "有效" : "封停";
          let active = true;
          if (employee.status !== 0) active = false;
          if (employee.leadsReceiveStatus === 0) active = false;
          leadsOwner.push({
            active,
            value: employee.userId,
            label: `${employee.name} - ${employee.userGroupName}`,
          });
        });
        setLeadsOwners(leadsOwner);

      });
  }
  useEffect(() => {
    getOwnerIds();
  }, []);
  const getList = (params) => new Promise((res, rej) => {
    if (params.id || params.pageIndex === 1) {
      RPCFactory.leadsManage
        .accountCallRecords(params)
        .done((data) => {
          renderList = data.entities

          res({
            list: data.entities,
            page_info: {
              total_number: _.get(data, 'page_info.total_number') || 0,
            },
          });
        })
        .fail((ret, msg) => {
          alert(`请求失败，msg:${msg}`);
        });
    }
  });
  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        console.log(params, 111222)
        setCallStatus(params.callStatus)

        const obj = { ...params };
        delete obj.page_size;
        delete obj.page;
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        if ([2, 4].includes(params.callStatus)) {
          delete obj.callFailReasons
        }
        // else if (params.callStatus === 1 && !obj.callFailReasons?.length) {
        // obj.callFailReasons = [1, 2, 3, 4, 5, 6, 7, 8, 10]
        // delete obj.callStatus
        // }
        if (params.addTime) {
          obj.startDate = params.addTime.start_time;
          obj.endDate = params.addTime.end_time;

        }
        if (params.pageIndex === 1) {
          // 第一页
          obj.id = 0
        } else if (params.page - CMcurrentPage === 1) {
          // 下一页
          obj.pageDown = true;
          obj.id = renderList[params.page_size - 1]?.id
        } else if (params.page - CMcurrentPage === -1) {
          // 上一页
          obj.pageDown = false;
          obj.id = renderList[0]?.id
        }
        CMcurrentPage = params.page
        // console.log('-09', obj.callFailReason?.length === 0, obj.callFailReason?.length)
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },

    filterConfig: {
      resetable: true,
      controls: filterControls(),
      // customConfigure: customFilterConfigure,
      defaultValuesByKey: initQuery,
    },

    tableConfig: {
      defaultPageSize: 10,
      paginationConfig: {
        type: 'mini'
      },
      // select: valid('WX_WORK_CUSTOMER_EDIT_TAGS') && !isServiceProvider ? 'multiple' : null,
      columns: columnMap.map(item => {
        return item.notice ? {
          ...item, title:
            <>
              {item.title}
              <OverlayTrigger
                trigger="hover"
                overlay={
                  <PopOver classNameName="spaui-popover-transet">
                    <div className="transet-popover">
                      <p className="txt" dangerouslySetInnerHTML={{ __html: item.notice }}>
                      </p>
                    </div>
                  </PopOver>
                }
              >
                <i className="spaui-icon icon-help"></i>
              </OverlayTrigger>
            </>
        } : item;
      }),
      rowKey: '_id',
      // onOptionalChange: handleRowSelect,
      // optionalConfig: {
      //   max: 20,  // 数值会被 canOptional 顶掉不起作用，但是可以让全选框消失
      //   canOptional: ({ _id, _data }) => {
      //     const max = 20;
      //     if (_data.deleteStatus === 1) return false;
      //     if (selectedRows.indexOf(_id) !== -1) return true;
      //     return selectedRows.length < max;
      //   },
      // },
    },
  });
  return (
    <div className="page-transet">
      <div classNameName="secs">
        <div className="card">
          <div className={'panel on'}>
            <div className="panel-heading">
              {/* <p className="panel-title">
              </p> */}
              <ListView
                className="lv"
                ref={lvRef}
                options={lvOptions}
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  )
};

export default FieldPage;
